import { createSelector } from '@ngrx/store';
import { PageState } from '../models/assessment-models';

export const selectNextPage = (state: any): PageState => state.page;

export const selectNextPageState = createSelector(selectNextPage, (state) => state?.page);

export const selectNextPageLoading = createSelector(selectNextPageState, (state) => state?.loading);

export const selectNextPageError = createSelector(selectNextPageState, (state) => state?.error);
